import {AEntity} from "../../../shared/abstract/a.entity";
import {ICampaign} from "../interface/i.campaign";
import {IImage} from "../../image/interface/i.image";
import {IFundraiser} from "../../fundraiser/interface/i.fundraiser";

export class ECampaign extends AEntity implements ICampaign.DTO {

  documentId!: string;
  title!: string;
  slug!: string;
  active!: boolean;
  isGroup!: boolean;
  progress_bar_html!: string;
  currency!: string;
  photo_url!: string;
  url!: string;
  description!: string;
  publishedAt!: string;
  locale!: string;
  content!: string;
  firstPartOfContent!: string;
  detailsPageQuickDonationUrl!: string;
  fundraiser!: IFundraiser.DTO | null;
  campaign?: ICampaign.DTO | null;
  campaigns?: ICampaign.DTO[];
  donorbox!: ICampaign.IDonorbox;
  donorbox_id!: number;
  photo!: IImage;
  banner!: IImage;
  hide_become_a_fundraiser_button!: boolean | null;
  top_fundraisers_custom_text!: string | null;

  public get showBecomeAFundraiserButton() {
    return this.hide_become_a_fundraiser_button !== true;
  }

  public getDonorBoxIdListOfParentAndChildren(): number[] {
    return [this.donorbox_id, ...this.getChildrenEntities().map(({donorbox_id}) => donorbox_id)];
  }

  public getCampaigns(withParent: boolean = true): ECampaign[] {
    const campaigns = (this.campaigns ?? []).map((campaign: ICampaign.DTO) => new ECampaign(campaign));
    return withParent ? [this, ...campaigns] : campaigns;
  }

  public hasParent(): boolean {
    return !!this.campaign;
  }

  public hasChildren(): boolean {
    return !!this.campaigns?.length;
  }

  public hasNotChildren(): boolean {
    return !this.hasChildren();
  }

  public getChildrenEntities(): ECampaign[] {
    if (this.hasChildren()) {
      return this.campaigns!.map((campaign: ICampaign.DTO) => new ECampaign(campaign));
    }
    return [];
  }

  public getParentEntity(): ECampaign | null {
    if (this.hasParent()) {
      return new ECampaign(this.campaign!);
    }
    return null;
  }

  public getCurrency(): string {
    return {
      'EUR': 'EUR',
      'eur': 'EUR',
      'usd': 'USD',
      'USD': 'USD',
    }[this.currency ?? this.donorbox?.currency] ?? 'EUR';
  }

  public getTotalRaised(): number {
    let totalRaised = 0;
    if (this.donorbox) {
      totalRaised = parseFloat(this.donorbox.total_raised);
      if (this.hasChildren()) {
        this.campaigns!.forEach((campaign: ICampaign.DTO) => {
          if (campaign.donorbox) {
            totalRaised += parseFloat(campaign.donorbox.total_raised);
          }
        });
      }
    }
    return totalRaised;
  }

  public getGoalAmount(withChildren = true): number {
    let goalAmount = 0;
    if (this.donorbox) {
      goalAmount = parseFloat(this.donorbox.goal_amt);
      if (this.hasChildren() && withChildren) {
        this.campaigns!.forEach((campaign: ICampaign.DTO) => {
          if (campaign.donorbox) {
            goalAmount += parseFloat(campaign.donorbox.goal_amt);
          }
        });
      }
    }
    return goalAmount;
  }

  public getDonations(): number {
    let donations = this.donorbox.donations_count;
    if (this.hasChildren()) {
      this.campaigns!.forEach((campaign: ICampaign.DTO) => {
        if (campaign.donorbox) {
          donations += campaign.donorbox.donations_count;
        }
      });
    }
    return donations;
  }

}
